module.exports = __webpack_public_path__ + "static/media/down-arrow.d8f5791e.svg";